export default __webpack_public_path__ + "static/media/mail_ico.6327eec2.svg";